// extracted by mini-css-extract-plugin
module.exports = {"root":"SketchCanvasPreview_root__L1yJl","cannotDrop":"SketchCanvasPreview_cannotDrop__XzxzI"};